<template>
    <b-modal
        :visible="value"
        title="Upload Bukti Diterima"
        size="lg"
        centered
        no-close-on-backdrop
        @change="$emit('input', $event)"
    >
        <div class="mb-3">
            <div class="small text-muted">Barang/Jasa</div>
            <div class="font-weight-bold">{{ item ? item.itemType : "-" }}</div>
        </div>
        <div class="kas-kecil-upload-box">
            <div class="mb-2">
                <h6 class="form-title mb-2">Upload Bukti Diterima</h6>
                <b-button variant="pgiBtn" size="sm" @click="$emit('add-photo')">
                    <i class="fa fa-plus mr-1"></i>Tambah
                </b-button>
            </div>
            <div
                v-for="photo in photos"
                :key="photo.index"
                class="kas-kecil-upload-item"
            >
                <div class="upload-gadai-btn-wrapper">
                    <b-button
                        v-if="photo.publicUrl"
                        class="upload-gadai-btn"
                        variant="cancelBtn"
                        @click="$emit('preview-photo', photo)"
                    >
                        Lihat
                    </b-button>
                    <div class="browse-foto upload-gadai-btn">
                        <b-form-file
                            v-model="photo.file"
                            :state="Boolean(photo.file)"
                            :disabled="photo.isUploading"
                            accept=".pdf,application/pdf,image/*"
                            drop-placeholder="Drop file here..."
                            class="hide-upload-label"
                            @input="file => $emit('upload-photo', { photo, file })"
                        />
                        <b-button
                            variant="cancelBtn"
                            class="upload-gadai-btn"
                            :disabled="photo.isUploading"
                        >
                            <b-spinner v-if="photo.isUploading" small class="mr-1" />
                            <i v-else class="fa fa-upload mr-1"></i>
                            Upload
                        </b-button>
                    </div>
                </div>
                <small v-if="photo.fileName" class="text-muted d-block mt-2">{{ photo.fileName }}</small>
                <b-button
                    variant="dynamicDeleteBtn"
                    class="kas-kecil-photo-remove"
                    @click="$emit('remove-photo', photo.index)"
                >
                    <i class="fa fa-times"></i>
                </b-button>
            </div>
        </div>

        <template v-slot:modal-footer>
            <b-button variant="secondary" @click="$emit('input', false)">
                Batal
            </b-button>
            <b-button
                variant="pgiBtn"
                name="kasKecilSubmitReceiptBtn"
                :disabled="isSubmitting"
                @click="$emit('submit')"
            >
                <b-spinner v-if="isSubmitting" small class="mr-1" />
                Simpan
            </b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "modal-kas-kecil-upload-receipt",
    props: {
        value: { type: Boolean, default: false },
        item: { type: Object, default: null },
        photos: { type: Array, default: () => [] },
        isSubmitting: { type: Boolean, default: false },
    },
}
</script>

<style scoped>
.kas-kecil-upload-box {
    border: 1px solid #e4e7ea;
    border-radius: 4px;
    padding: 12px;
}

.form-title {
    color: #1f4e89;
    font-weight: 700;
}

.kas-kecil-upload-item {
    border: 1px solid #e4e7ea;
    border-radius: 4px;
    margin-top: 12px;
    padding: 12px 48px 12px 12px;
    position: relative;
}

.kas-kecil-photo-remove {
    position: absolute;
    right: 10px;
    top: 10px;
}

.kas-kecil-upload-box ::v-deep .form-group > legend {
    display: none;
}

.kas-kecil-upload-box ::v-deep .row > [class*="col-"] {
    flex: 0 0 100%;
    max-width: 100%;
}

.kas-kecil-upload-box ::v-deep .form-dynamic-wrapper {
    margin-bottom: 0 !important;
}

.upload-gadai-btn-wrapper {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.upload-gadai-btn {
    min-width: 96px;
}

.browse-foto {
    position: relative;
}

.browse-foto .custom-file {
    cursor: pointer;
    height: 34px;
    left: 0;
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 2;
}
</style>
